import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['popover', 'tooltip', 'offcanvas']

    connect() {
        // Detect when tooltip title changes and update the tooltip content
        this.tooltipTitleObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                const tooltipTarget = mutation.target
                const tooltip = bootstrap.Tooltip.getInstance(tooltipTarget)
                if (tooltip) {
                    const currentTitle = tooltipTarget.getAttribute('title')
                    if (currentTitle && currentTitle !== tooltip._config.title) {
                        tooltip.setContent({ '.tooltip-inner': currentTitle })
                    }
                }
            })
        })
    }

    disconnect() {
        // Clean up the shared observer when the controller is disconnected
        this.tooltipTitleObserver?.disconnect()
    }

    popoverTargetConnected(popoverTarget) {
        new bootstrap.Popover(popoverTarget, { sanitize: false })
    }

    popoverTargetDisconnected(popoverTarget) {
        const popover = bootstrap.Popover.getInstance(popoverTarget)
        popover?.dispose()
    }

    tooltipTargetConnected(tooltipTarget) {
        new bootstrap.Tooltip(tooltipTarget)

        this.tooltipTitleObserver?.observe(tooltipTarget, {
            attributes: true,
            attributeFilter: ['title'],
        })
    }

    tooltipTargetDisconnected(tooltipTarget) {
        const tooltip = bootstrap.Tooltip.getInstance(tooltipTarget)
        tooltip?.dispose()
    }

    offcanvasTargetConnected(offcanvasTarget) {
        new bootstrap.Offcanvas(offcanvasTarget)
    }

    toggleOffcanvas(event) {
        const { offcanvasTargetId } = event.params
        const offcanvasElement = document.getElementById(offcanvasTargetId)
        if (offcanvasElement) {
            const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement)
            offcanvas?.toggle()
        }
    }

    offcanvasTargetDisconnected(offcanvasTarget) {
        const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasTarget)
        offcanvas?.dispose()
    }
}
